import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";

const HomePage = lazy(() => import("./Home"));

const App = () => (
  <Router>
    <Link to="/"></Link>
    <Suspense
      fallback={
        <div class="loader-container">
          <div class="loader"></div>
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<HomePage />}></Route>
      </Routes>
    </Suspense>
  </Router>
);

export default App;
